import(/* webpackMode: "eager" */ "/microservice/src/app/not-found.tsx");
